import React from 'react';
import { CustomAccordion } from '../../../shared';
import {
    KpiDefinition,
    ReplimuneClinicalTrialDef,
    ReplimuneHCPDefinition,
} from '../../../../constants';
import Notes from '../../../shared/notes';
import { useSelector } from 'react-redux';

const WebMetricsNote = () => {
    const { company } = useSelector((state) => state.company);
    const hideBounceRateCompanies = [61, 66, 64, 94, 91];
    const noteDataItems = {
        64: ReplimuneClinicalTrialDef,
        140: ReplimuneHCPDefinition,
        161: ReplimuneHCPDefinition,
        66: ReplimuneHCPDefinition,
        default: hideBounceRateCompanies.includes(company.id)
            ? KpiDefinition.filter((item) => item.key !== 'Bounce rate')
            : KpiDefinition,
    };
    const noteData = noteDataItems[company.id] || noteDataItems.default;

    return (
        <CustomAccordion
            acoordianDetailsBackground="bg-white"
            acoordianDetailsPadding="padding-t-8-b-16"
            component={<Notes Definition={noteData} />}
            title="Metrics Information"
        />
    );
};

export default WebMetricsNote;
